// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140229/js/" + chunkId + "." + {"44":"4a7a85c7","225":"68a7c33a","481":"949afac1","486":"5109f538","770":"8e251775"}[chunkId] + ".0.20146661156180723.chunk.js";
};